import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconPresentGiftCouponSide } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'
import { IMAGE_PRODUCT_FALLBACK_SRC } from '../../../image/IMAGE_PRODUCT_FALLBACK_SRC'
import { useProductPromotion } from '../../../product-page/components/ProductDescription/ProductDescriptionPromotions/useProductPromotion'
import { useProductPageContext } from '../../../product-page/components/productPageContext'
import { ProductPicture } from '../../../product/components/ProductPicture'
import { EXPERIMENT_VARIATION } from '../../model/EXPERIMENT_VARIATION'
import { useExperimentalAddStaticFileHost } from '../../new-cdn-experiment/useExperimentalAddStaticFileHost'

import { experimentFreeGiftPromotionTranslations } from './translations'
import { useGetFreeGiftPromotionsExperiment } from './useGetFreeGiftPromotionsExperiment'

export const ExperimentFreeGiftPromotion: FC<{ isMobile?: boolean }> = ({
  isMobile,
}) => {
  const { promotionProduct } = useProductPageContext()
  const intl = useIntl()
  const {
    hasPromotion,
    promotionDescription,
    promotionFooter,
    promotionTitle,
  } = useProductPromotion()
  const { locale } = useGlobalConfigContext()

  const { isEnabled, name, variant } =
    useGetFreeGiftPromotionsExperiment(isMobile)
  const { addStaticCdnHostToUrl } = useExperimentalAddStaticFileHost()

  return hasPromotion &&
    isEnabled &&
    variant !== EXPERIMENT_VARIATION.DEFAULT ? (
    <div
      className={clsx(
        'mb-2 flex bg-light-primary-medium text-dark-primary-max',
        variant === EXPERIMENT_VARIATION.V1 && 'rounded-lg p-4',
        variant === EXPERIMENT_VARIATION.V2 &&
          'mt-4 border-t-2 border-dark-primary-min pt-4',
      )}
      data-qa-id={name}
    >
      <Button<'a'>
        className="relative pr-4"
        data-qa-id="form-promotion-button"
        slots={{ root: 'a' }}
        variant="text"
      >
        <ProductPicture
          className="rounded-md bg-light-primary-low"
          fallbackSrc={addStaticCdnHostToUrl(IMAGE_PRODUCT_FALLBACK_SRC)}
          imageProps={{
            alt: intl.formatMessage({
              id: 'general.label.product.oneforone',
            }),
            className: 'rounded-md',
            height: 168,
            // Fallback returned from BuLLy https://github.com/RedTecLab/bully/blob/master/src/services/offers-v1/model/offerProductResponse.ts#L57
            src: promotionProduct?.product?.productImg?.includes(
              'placeholder.png',
            )
              ? undefined
              : promotionProduct?.product?.productImg,
            width: 168,
          }}
        />
      </Button>
      <div className="flex flex-col gap-2">
        <div className="flex">
          <IconPresentGiftCouponSide className="mr-2 size-6 text-dark-brand" />{' '}
          <span className="text-m font-medium text-dark-primary-max">
            {`${experimentFreeGiftPromotionTranslations[locale]}:`}
          </span>
        </div>
        <span
          className="font-medium text-dark-primary-max"
          data-qa-id="promotion-product-title"
        >
          {promotionTitle}
        </span>
        <span className="text-xs text-dark-primary-strong">
          {promotionDescription}
          {promotionFooter}
        </span>
      </div>
    </div>
  ) : null
}
